
import Vue from 'vue'

export interface SelectionAccordionOption {
   name: string
   value: string
   disabled?: boolean
   component?: Vue.Component
   infoComponent?: Vue.Component
}

export default Vue.extend({
   name: 'SelectionAccordion',
   props: {
      name: { type: String, default: 'group' },
      value: { type: String, default: '' },
      options: { type: Array as () => SelectionAccordionOption[], required: true },
   },
   methods: {
      setOption(option: string) {
         if (option !== this.value) {
            this.$emit('input', option)
         }
      },
   },
})
